import * as React from 'react';
import { SchoolEventIndividualData } from 'Src/models/event';
import {
  convertPointsToStringWithoutDelimeter,
  getExtraPointsByStudent,
  getIndividualScoreByStudent
} from '../../../../../../../helpers/event/schoolEventViewHelper';
import { isEventStatusFinished } from '../../../../../../../helpers/event/event';
import { SchoolEvent } from '../../../../../../../models/event';
import { Child } from 'Src/models/child';
import { EventParticipantIdentity } from 'Src/components/EventParticipantIdentity/EventParticipantIdentity';
import { Report } from 'Src/models/report';
import { AvailabilityStatusDot } from 'Src/components/AvailabilityStatusDot/AvailabilityStatusDot';

interface Props {
  players: SchoolEventIndividualData[];
  event: SchoolEvent;
  ownedChildren: Child[];
  availabilityReports: Report[];
}

export function ChildrenEventIndividualPlayers(props: Props) {
  const { players, event, ownedChildren, availabilityReports } = props;
  const ownedIds = new Set(ownedChildren.map(child => String(child.id)));
  const availabilityByPermission = availabilityReports.reduce((result, report) => {
    const key = String(report.playerDetails && report.playerDetails.permissionId || '');
    const previous = result.get(key);
    if (key && (!previous || new Date(report.createdAt).getTime() > new Date(previous.createdAt).getTime())) result.set(key, report);
    return result;
  }, new Map<string, Report>());
  const sortedPlayers = [...players].sort((a, b) => {
    const ownedDifference = Number(ownedIds.has(String(b.userId))) - Number(ownedIds.has(String(a.userId)));
    if (ownedDifference !== 0) return ownedDifference;
    return `${a.lastName || ''} ${a.firstName || ''}`.localeCompare(`${b.lastName || ''} ${b.firstName || ''}`);
  });

  const rows = sortedPlayers.map((player, playerIndex) => {
    const { userId, permissionId } = player;
    const playerPoints = getIndividualScoreByStudent(event, userId, permissionId);
    const playerPointsStr = convertPointsToStringWithoutDelimeter(event, playerPoints);
    const extraPoints = getExtraPointsByStudent(event, userId);
    const extraPointsStr = String(extraPoints);
    const isEventFinished = isEventStatusFinished(event);
    const ownedChild = ownedChildren.find(child => String(child.id) === String(userId));
    const availability = availabilityByPermission.get(String(permissionId));

    return (
      <tr key={`school_players_${player.id}`} className={ownedChild ? 'eventParticipantRow--owned' : ''}>
        <td className="eventParticipantRow__number">
          <div>{`${playerIndex + 1} `}</div>
        </td>

        <td style={{ width: '25%' }}>
          <div className={'ml-3'}>
            <div className="parentAvailabilityIdentity">
              <EventParticipantIdentity
                firstName={player.firstName}
                lastName={player.lastName}
                isOwned={!!ownedChild}
                avatar={ownedChild && ownedChild.avatar}
                ownedLabel="Your child"
              />
              {ownedChild && <AvailabilityStatusDot report={availability} />}
            </div>
          </div>
        </td>

        <td style={{ width: '25%' }}>
          <div className="ml-3 eventParticipantLastName">{player.lastName}</div>
        </td>

        <td style={{ width: '30%' }}>
          {isEventFinished && <div className={'ml-3 font-weight-bold'}>{`${playerPointsStr} `}</div>}
        </td>

        <td style={{ width: '15%' }}>
          {isEventFinished && <div className={'ml-3 font-weight-bold'}>{`${extraPointsStr} `}</div>}
        </td>
      </tr>
    );
  });
  return (
    <table className={'w-100 eventParticipantRoster'}>
      <tbody>{rows}</tbody>
    </table>
  );
}
